import classNames from 'classnames';
import { ForwardedRef } from 'react';

import List, { ListItem, ListProps } from './List';

import styles from '../../styles/lists/inline-list.module.css';

function InlineList<T = ListItem>({
    className = null,
    itemsClassName = null,
    itemClassName = null,
    ref: listRef = null,
    ...props
}: ListProps<T> & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    return (
        <List<T>
            {...props}
            ref={listRef}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            itemsClassName={classNames([
                styles.items,
                {
                    [itemsClassName]: itemsClassName !== null,
                },
            ])}
            itemClassName={classNames([
                styles.item,
                {
                    [itemClassName]: itemClassName !== null,
                },
            ])}
        />
    );
}

export default InlineList;
